/**
 * @file ConsentRevisionList.tsx
 * @description Прежние редакции текстов согласия (phase19.16, Р3г;
 * uiux-r3g-consent-texts §2, §5): «Ред. N · дата · автор · «заметка» ›»,
 * строки от 56 px, заметка — в две строки (полный текст — в «Смотреть»),
 * по 20 строк и «Показать ещё». Образец строки — `LegalRevisionHistory`.
 */

import { ChevronRight } from "lucide-react";
import { useState } from "react";

import type { ConsentTextRevisionListItem } from "../../../lib/api-consent-texts";
import { revisionLine } from "../../../lib/platform/consent-texts-format";
import { Button } from "../../ui/button";

/** Сколько строк показывать за раз. */
const CONSENT_HISTORY_PAGE = 20;

interface Props {
  items: readonly ConsentTextRevisionListItem[];
  onView: (number: number) => void;
}

export function ConsentRevisionList({ items, onView }: Props) {
  const [shown, setShown] = useState(CONSENT_HISTORY_PAGE);
  return (
    <div className="flex flex-col gap-2">
      <ul className="m-0 flex list-none flex-col divide-y divide-[var(--border)] p-0">
        {items.slice(0, shown).map((r) => (
          <li key={r.number}>
            <button
              type="button"
              aria-label={`Смотреть редакцию ${r.number}`}
              onClick={() => onView(r.number)}
              className="flex min-h-14 w-full items-center gap-3 rounded-md py-2 text-left outline-none hover:bg-surface-low focus-visible:ring-2 focus-visible:ring-ring"
            >
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="type-body text-on-surface">{revisionLine(r)}</span>
                {r.note ? <span className="type-caption line-clamp-2 break-words text-on-surface-variant">«{r.note}»</span> : null}
              </span>
              <ChevronRight className="size-4 shrink-0 text-on-surface-variant" aria-hidden />
            </button>
          </li>
        ))}
      </ul>
      {items.length > shown ? (
        <Button variant="outline" className="min-h-12 self-start" onClick={() => setShown((n) => n + CONSENT_HISTORY_PAGE)}>
          Показать ещё
        </Button>
      ) : null}
    </div>
  );
}
